import { Helmet } from 'react-helmet-async'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faStoreAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, BlankState, Button, Columns, LoadingModule,
} from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import { generateUrls } from '@hooks/useCustomItem'
import useCustomItemGroup from '@hooks/useCustomItemGroup'
import useCustomItemGroups from '@hooks/useCustomItemGroups'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import blankImageUrl from '@components/ListBlankState/assets/filterBlankState.svg'

import CustomItemGroup from '../CustomItemGroup'

interface PageContentProps {
  pageFilters: {},
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const { selectedAgencyId } = useAgencySelector()

  const customItemGroupsPayload = useCustomItemGroups({
    filters: {
      agency_id: selectedAgencyId,
      ...pageFilters,
    },
    performHttpRequests: !!selectedAgencyId,
    requestOptions: {
      include_custom_item_group_custom_items: !!selectedAgencyId,
    },
  })

  const {
    filteredCustomItemGroups,
    hasFilteredCustomItemGroups,
    loading,
  } = customItemGroupsPayload

  const useCustomItemGroupPayload = useCustomItemGroup({ agency_id: selectedAgencyId })
  const {
    callbacks:
     { createOrEditCustomItemGroup },
  } = useCustomItemGroupPayload

  const { customItemsIndexUrl } = generateUrls({}, { prefixRoute: `agencies/${selectedAgencyId}/manage` })

  return (
    <>
      <Helmet>
        <title>Custom Items | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" onClick={() => createOrEditCustomItemGroup()} size="medium">
            Create Group
          </Button>
        )}
        activeTabBarItemKey="custom_items"
        nestedNavigation
        tabBarItems={[
          {
            href: customItemsIndexUrl,
            icon: faStoreAlt,
            key: 'custom_items',
            title: 'Custom Items',
          },
        ]}
        title="Custom Items"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.customItems.banner" />

            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredCustomItemGroups && (
              <BlankState boxProps={{ marginBottom: ['large', 0] }} imageUrl={blankImageUrl}>
                {/*
                 // @ts-expect-error TS2339 */}
                <BlankState.Title>
                  No Custom Items Present.
                  {/*
                 // @ts-expect-error TS2339 */}
                </BlankState.Title>

                {/*
                 // @ts-expect-error TS2339 */}
                <BlankState.Paragraph>
                  Create a group to add items.
                  {/*
                 // @ts-expect-error TS2339 */}
                </BlankState.Paragraph>

                {/*
                 // @ts-expect-error TS2339 */}
                <BlankState.Actions>
                  <Button
                    buttonStyle="secondaryEdit"
                    icon={<FontAwesomeIcon icon={faPlusCircle} />}
                    onClick={() => createOrEditCustomItemGroup()}
                    // @ts-expect-error TS2322
                    size={['medium', 'small']}
                    width={['100%', 'fit-content']}
                  >
                    Create Group
                  </Button>
                  {/*
                 // @ts-expect-error TS2339 */}
                </BlankState.Actions>
              </BlankState>
            )}

            {!loading && filteredCustomItemGroups.map(customItemGroup => (
              <CustomItemGroup key={customItemGroup.id} customItemGroup={customItemGroup} />
            ))}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.customItems.sidebar" />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
